export default "__VITE_ASSET__dc633984__"